import { create } from 'zustand';

interface flowMenuDataState {
  data: { page: any };
  set: (data: any) => void;
  bind: (data: any) => void;
}

interface pageInitState {
  data: { init: boolean };
  set: (data: { init: boolean }) => void;
}

/**
  flowMenu 상태관리
**/
export const flowMenuDataStore = create<flowMenuDataState>(set => ({
  data: { page: null, viewType: '' },
  set: (data: any) => set(state => ({ ...state, data: data })),
  bind: (data: any) =>
    set(state => ({
      ...state,
      data: { ...state.data, ...data },
    })),
}));

/**
  page 초기상태
**/
export const pageInitStore = create<pageInitState>(set => ({
  data: { init: false },
  set: (data: any) => set(state => ({ ...state, data: data })),
}));
